import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

interface PatternStatusIndicatorProps extends Omit<SvgIconProps, 'viewBox'> {
  hasSolution: boolean;
  hasLatexSolution: boolean;
  hasSkillSolution: boolean;
  isStatic: boolean;
  isReferencePattern: boolean;
  hasPublicSolution: boolean;
}

const PatternStatusIndicator: React.FC<PatternStatusIndicatorProps> = ({
  hasSolution,
  hasLatexSolution,
  hasSkillSolution,
  isStatic,
  isReferencePattern,
  hasPublicSolution,
  ...svgProps
}) => {
  // Couleurs pour chaque point
  const colorActive = '#1976d2'; // Bleu
  const colorInactive = '#bdbdbd'; // Gris

  // Déterminer la couleur de chaque point
  const color1 = hasSolution ? colorActive : colorInactive;
  const color2 = hasLatexSolution ? '#4caf50' : colorInactive; // Vert
  const color3 = hasSkillSolution ? '#ff9800' : colorInactive; // Orange
  const color4 = isStatic ? '#9c27b0' : colorInactive; // Violet
  const color5 = isReferencePattern ? '#f44336' : colorInactive; // Rouge
  const color6 = hasPublicSolution ? '#00bcd4' : colorInactive; // Cyan

  return (
    <SvgIcon {...svgProps} viewBox="0 0 24 24">
      {/* Ligne 1 */}
      <circle cx="9" cy="6" r="2" fill={color1} />
      <circle cx="15" cy="6" r="2" fill={color4} />

      {/* Ligne 2 */}
      <circle cx="9" cy="12" r="2" fill={color2} />
      <circle cx="15" cy="12" r="2" fill={color5} />

      {/* Ligne 3 */}
      <circle cx="9" cy="18" r="2" fill={color3} />
      <circle cx="15" cy="18" r="2" fill={color6} />
    </SvgIcon>
  );
};

export default PatternStatusIndicator;
